import React from 'react'
import { renderMarkdown } from '../../modules/utils.js'

interface MdRendererProps {
  content: string
  className?: string
  style?: React.CSSProperties
}

export function MdRenderer({ content, className, style }: MdRendererProps) {
  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
    />
  )
}
